import { render, staticRenderFns } from "./Decrease.vue?vue&type=template&id=c5025620&"
import script from "./Decrease.vue?vue&type=script&lang=js&"
export * from "./Decrease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports